<app-tab>
  <dx-data-grid
    id="trailersGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{ stateStorageKey: 'app-trailers2-grid' }"
    [libGridTitle]="{ text: 'Machines & Outils' }"
    (onEditingStart)="onEditingStart($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowUpdating)="onRowUpdating($event)"
  >
    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataType="number"
    >
    </dxi-column>

    <dxi-column caption="Code" dataField="code" dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="async"
        message="Code existe déjà"
        [validationCallback]="codeValidation"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      *ngIf="
        systemColumns.length > 0 &&
        (canListThirdPartSystems || canEditThirdPartSystems)
      "
      caption="Systèmes extérieurs"
      [columns]="systemColumns"
    >
    </dxi-column>

    <dxi-column caption="Nom" dataField="name">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="150"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column caption="RFID" dataField="rfid">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Cartes"
      cellTemplate="tagsCountTemplate"
      [allowEditing]="false"
      [visible]="canListTags"
      [formItem]="{ visible: false }"
      dataField="tags_count"
    >
    </dxi-column>

    <div *dxTemplate="let data of 'tagsCountTemplate'">
      <a
        href="#"
        (click)="showTags($event, data.data)"
        class="w-full flex items-center justify-end"
      >
        <ic-icon
          [icon]="tagsIcon"
          width="18px"
          height="18px"
          [inline]="true"
        ></ic-icon>
        <div class="px-1">({{ data.value }})</div>
      </a>
    </div>

    <dxi-column caption="Largeur (cm)" dataType="number" dataField="width">
      <dxi-validation-rule type="numeric" [min]="0"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Type d'opération"
      dataType="string"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="operation_type.name"
    >
    </dxi-column>

    <dxi-column caption="Marque" dataField="brand">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="150"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column caption="Modèle" dataField="model">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="150"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Année de production"
      dataType="number"
      dataField="production_year"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Date d'acquisition"
      dataField="acquisition_date"
      format="shortDate"
      cellTemplate="acquisitionDateTemplate"
      dataType="date"
    >
      <dxo-form-item
        editorType="dxDateBox"
        [editorOptions]="{ type: 'date' }"
      ></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <div *dxTemplate="let cell of 'acquisitionDateTemplate'">
        {{ !cell.data.is_subcontract ? cell.text : "NA" }}
      </div>
    </dxi-column>

    <dxi-column
      caption="Age"
      dataType="string"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{ visible: false }"
      dataField="age"
    >
    </dxi-column>

    <dxi-column
      caption="État"
      dataType="string"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{ visible: false }"
      dataField="age_status"
    >
    </dxi-column>

    <dxi-column
      caption="Valeur d'acquisition"
      dataField="acquisition_value"
      format="#,##0.## DHs"
      cellTemplate="acquisitionValueTemplate"
      dataType="number"
    >
      <dxo-form-item
        editorType="dxNumberBox"
        [editorOptions]="{ format: '#,##0.## DHs' }"
      ></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <div *dxTemplate="let cell of 'acquisitionValueTemplate'">
        {{ !cell.data.is_subcontract ? cell.text : "NA" }}
      </div>
    </dxi-column>

    <dxi-column
      caption="Mode d'aquisition"
      [showEditorAlways]="false"
      falseText="Locale"
      trueText="Sous-traité"
      dataType="boolean"
      editCellTemplate="subcontractEditor"
      dataField="is_subcontract"
    >
      <div *dxTemplate="let cellInfo of 'subcontractEditor'">
        <div style="height: 35px" class="flex felx items-center h-full">
          <dx-switch
            [value]="cellInfo.value"
            (onValueChanged)="subContractChange($event, cellInfo)"
          ></dx-switch>
        </div>
      </div>
    </dxi-column>

    <dxi-column
      caption="Domaine"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="domain_name"
    >
    </dxi-column>

    <dxi-column
      caption="BU"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="business_unit_name"
    >
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Domaine"
      dataField="domain_id"
      editCellTemplate="domainChooser"
      [visible]="false"
      [showInColumnChooser]="false"
    >
      <div *dxTemplate="let cellInfo of 'domainChooser'">
        <app-user-domains-chooser
          (valueChange)="cellInfo.setValue($event)"
          [id]="cellInfo.value"
        ></app-user-domains-chooser>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Type d'opération"
      dataField="operation_type_id"
      [visible]="false"
      [showInColumnChooser]="false"
    >
      <dxo-lookup
        [dataSource]="operations"
        valueExpr="id"
        displayExpr="name"
      ></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Vitesse Minimale"
      dataType="number"
      dataField="operation_type_rules.min_speed"
      [visible]="false"
      [allowFiltering]="false"
      [allowSearch]="false"
      [showInColumnChooser]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Vitesse Maximale"
      dataType="number"
      dataField="operation_type_rules.max_speed"
      [visible]="false"
      [allowSearch]="false"
      [allowFiltering]="false"
      [showInColumnChooser]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Pression Maximale"
      dataType="number"
      dataField="operation_type_rules.max_pressure"
      [visible]="false"
      [showInColumnChooser]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Pression Minimale"
      dataType="number"
      dataField="operation_type_rules.min_pressure"
      [visible]="false"
      [showInColumnChooser]="false"
    >
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit"
    >
      <dxo-popup width="50%" [deferRendering]="false"></dxo-popup>

      <dxo-form
        labelLocation="top"
        [colCount]="1"
        [showValidationSummary]="true"
      >
        <dxi-item itemType="group" colCount="2" caption="Général">
          <dxi-item dataField="code"></dxi-item>
          <dxi-item dataField="name"></dxi-item>
          <dxi-item dataField="rfid"></dxi-item>
          <dxi-item dataField="width"></dxi-item>
          <dxi-item dataField="brand"></dxi-item>
          <dxi-item dataField="model"></dxi-item>
          <dxi-item dataField="production_year"></dxi-item>
          <dxi-item dataField="operation_type_id"></dxi-item>
          <dxi-item dataField="domain_id"></dxi-item>
        </dxi-item>

        <dxi-item
          *ngIf="canEditThirdPartSystems"
          itemType="group"
          colCount="2"
          [items]="systemColumns"
          caption="Systèmes extérieurs"
        ></dxi-item>

        <dxi-item itemType="group" colCount="2" caption="Règles">
          <dxi-item dataField="operation_type_rules.min_speed"></dxi-item>
          <dxi-item dataField="operation_type_rules.max_speed"></dxi-item>
          <dxi-item dataField="operation_type_rules.min_pressure"></dxi-item>
          <dxi-item dataField="operation_type_rules.max_pressure"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" colCount="4" caption="Calibration">
          <dxi-item
            dataField="operation_type_settings.lower_pressure"
          ></dxi-item>
          <dxi-item
            dataField="operation_type_settings.upper_pressure"
          ></dxi-item>
          <dxi-item
            dataField="operation_type_settings.lower_voltage"
          ></dxi-item>
          <dxi-item
            dataField="operation_type_settings.upper_voltage"
          ></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" colCount="3" caption="Acquisition">
          <dxi-item
            *ngIf="!isSubContract"
            dataField="acquisition_date"
          ></dxi-item>
          <dxi-item
            *ngIf="!isSubContract"
            dataField="acquisition_value"
          ></dxi-item>
          <dxi-item
            [label]="{ text: 'Sous-Traité?' }"
            dataField="is_subcontract"
          ></dxi-item>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxi-column
      caption="haute pression"
      dataType="number"
      dataField="operation_type_settings.upper_pressure"
    >
    </dxi-column>

    <dxi-column
      caption="basse pression"
      dataType="number"
      dataField="operation_type_settings.lower_pressure"
    >
    </dxi-column>

    <dxi-column
      caption="haute tension"
      dataType="number"
      dataField="operation_type_settings.upper_voltage"
    >
    </dxi-column>

    <dxi-column
      caption="basse tension"
      dataType="number"
      dataField="operation_type_settings.lower_voltage"
    >
    </dxi-column>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export
      [enabled]="true"
      fileName="liste-outils-"
      [allowExportSelectedData]="true"
    ></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true"
    >
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>
  </dx-data-grid>
</app-tab>

<dx-popup
  width="70%"
  [showTitle]="true"
  [title]="'Cartes ' + taggable?.taggable_name"
  class="tags-viewer-popup"
  [(visible)]="tagsPopupVisible"
>
  <div *dxTemplate="let data of 'content'">
    <lib-tags-viewer [taggable]="taggable"></lib-tags-viewer>
  </div>
</dx-popup>
